import { useQuery } from 'react-query'
import { getTaxon } from 'services/requests/taxons'

export const useGetTaxon = (code: string) => {
    return useQuery(
        ['taxon', code],
        () => getTaxon(code),
        {enabled: !!code}
    )
}